import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import AdTypeMenuHeading from './AdTypeMenuHeading';
import AdTypeSimpleMenuItem from './AdTypeSimpleMenuItem';

const AdTypeIsiMenu = ({ onSelectMenu, $state }) => {
  const goToIsiVideo = () =>
    $state.go('creativePreview.edit.example', {
      id: 'isiInstantPlayCard',
      is_isi: true
    });

  const goToIsiDisplay = () =>
    $state.go('creativePreview.edit.example', { id: 'isiWebsiteVisit' });

  return (
    <Fragment>
      <AdTypeMenuHeading
        onClick={() => onSelectMenu('main')}
        title="Native ISI"
      />
      <AdTypeSimpleMenuItem
        heading="ISI Video"
        onClick={goToIsiVideo}
        testId="isi-video"
      />
      <AdTypeSimpleMenuItem
        heading="ISI Display"
        onClick={goToIsiDisplay}
        testId="isi-display"
      />
    </Fragment>
  );
};

AdTypeIsiMenu.propTypes = {
  $state: PropTypes.object.isRequired,
  onSelectMenu: PropTypes.func.isRequired
};

export default AdTypeIsiMenu;
